import React, { lazy, Suspense } from "react";

const LoginComponent = lazy(() => import("../components/Login"));

const renderLoader = () => <p>Loading</p>;

const LoginScreen = () => {
  return (
    <>
      <Suspense fallback={renderLoader()}>
        <LoginComponent />
      </Suspense>
    </>
  );
};

export default LoginScreen;
